export default __webpack_public_path__ + "static/media/scrabble-1440w.3d7049d8.png";